import type { Plan } from "@/lib/gql/__generated__/graphql";

import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { shouldShowScConnectedToggle } from "@/components/features/items/edit/plan/_shared/ui/components/sc-connected";

import { PlanList_PlanListPage_Query } from "./query";

type Props = {
	hotelID: string;
};

export const useFetchPlanList = ({ hotelID }: Props) => {
	const { data } = useCustomSuspenseQuery(PlanList_PlanListPage_Query, {
		variables: { hotelID },
		fetchPolicy: "network-only",
	});

	const plans: Plan[] =
		data?.planList.plans.map((item) => {
			const { __typename, ...plan } = item;

			return { ...plan } satisfies Plan;
		}) ?? [];

	const secrets: Plan[] =
		data?.planList.secrets.map((item) => {
			const { __typename, ...plan } = item;

			return { ...plan } satisfies Plan;
		}) ?? [];

	const showScConnectedColumn =
		data?.siteControllerSetting?.siteControllerType !== undefined &&
		shouldShowScConnectedToggle({
			siteControllerType: data.siteControllerSetting.siteControllerType,
			setUpRoomPriceByChillnn: data.siteControllerSetting.setUpRoomPriceByChillnn,
		});

	return {
		data,
		plans,
		secrets,
		showScConnectedColumn,
	};
};
